/**
 * FooterTabBar の tab / tabpanel を紐づける id 生成ヘルパー。
 *
 * react-refresh の制約 (コンポーネントファイルからコンポーネント以外を export できない) のため、
 * footer-tab-bar.tsx とは別ファイルに切り出している。
 */

export const footerTabId = (idPrefix: string, value: string) => `${idPrefix}-tab-${value}`

export const footerTabPanelId = (idPrefix: string) => `${idPrefix}-panel`

/**
 * FooterTabBar が制御する tabpanel 側に展開する props を生成する。
 *
 * タブごとにパネル要素を分けず「中身が差し替わる単一パネル」構成を前提としており、
 * パネルの id は固定、`aria-labelledby` が選択中タブを指す形にしている。
 */
export const footerTabPanelProps = (idPrefix: string, activeValue: string) => ({
  id: footerTabPanelId(idPrefix),
  role: 'tabpanel' as const,
  'aria-labelledby': footerTabId(idPrefix, activeValue),
})
